import { useCallback } from "react";
import { clearLocalStorage } from "../helpers/logout";

export const useSignOut = () => {
  const signOut = useCallback(async () => {
    clearLocalStorage();
    window.location.replace("/sign_in/login_password");
  }, []);

  return signOut;
};
